import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Animated, Dimensions, Easing, Platform, View, TouchableHighlight, TouchableOpacity, Text} from 'react-native';

import ModalPortal from './Portal';
import * as ariaAppHider from './ariaAppHider';
import {SafeHTMLElement} from './utils';
import styles from './styles';
import Colors from "../../tools/Colors";
import Toast, {BaseToast} from "../../customviews/toast";
import {moderateScale} from "../../tools/Scaling";

let ariaHiddenInstances = 0;
const toastConfig = {
    /*
      overwrite 'success' type,
      modifying the existing `BaseToast` component
    */
    custom_success: (props) => (
        <BaseToast
            {...props}
            style={{borderLeftColor: Colors.green}}
            text1Style={{
                fontSize: moderateScale(15)
            }}
            text2Style={{
                fontSize: moderateScale(14)
            }}
        />
    ),
    custom_info: (props) => (
        <BaseToast
            {...props}
            style={{borderLeftColor: "#00abdd"}}
            text1Style={{
                fontSize: moderateScale(15)
            }}
            text2Style={{
                fontSize: moderateScale(14)
            }}
        />
    ),
    custom_error: (props) => (
        <BaseToast
            {...props}
            style={{borderLeftColor: 'red'}}
            text1Style={{
                fontSize: moderateScale(15)
            }}
            text2Style={{
                fontSize: moderateScale(14)
            }}
        />
    ),
    success: ({text1, props, ...rest}) => (
        <BaseToast
            {...rest}
            //  style={{borderLeftColor: 'pink'}}
            //contentContainerStyle={{paddingHorizontal: 15}}
            text1Style={{
                fontSize: moderateScale(40),
                //   fontWeight: '400'
            }}
            // text1={text1}
            // text2={props.uuid}
        />
    ),

    /*
      or create a completely new type - `my_custom_type`,
      building the layout from scratch
    */
    my_custom_type: ({text1, props, ...rest}) => (
        <View style={{height: moderateScale(60), width: '100%', backgroundColor: 'tomato'}}>
            <Text>{text1}</Text>
        </View>
    ),

};
export default class HMModal extends Component {
    static setAppElement(element) {
        ariaAppHider.setElement(element);
    }

    static propTypes = {
        animationType: PropTypes.oneOf(['none', 'slide', 'fade']),
        transparent: PropTypes.bool,
        isVisible: PropTypes.bool,
        onRequestClose:
            Platform.isTV || Platform.OS === 'android'
                ? PropTypes.func.isRequired
                : PropTypes.func,
        onShow: PropTypes.func,
        onDismiss: PropTypes.func,
        children: PropTypes.node.isRequired,
        ariaHideApp: PropTypes.bool,
        appElement: PropTypes.instanceOf(SafeHTMLElement),
    };

    static defaultProps = {
        //  animationType: 'none',
        animationType: 'slide',
        transparent: false,
        isVisible: true,
        onShow: () => {
        },
        onRequestClose: () => {
        },
        onDismiss: () => {
        },
        ariaHideApp: true,
        appElement: null,
    };

    constructor(props) {
        super(props);

        this.state = {
            animationSlide: null,
            animationFade: null,
            styleFade: {display: props.isVisible ? 'flex' : 'none'},
            opacityFade: new Animated.Value(0),
            slideTranslation: new Animated.Value(0),
        };
    }

    componentDidMount() {
        if (this.props.isVisible) this.handleShow();
    }

    componentWillReceiveProps({isVisible}) {
        if (isVisible && !this.props.isVisible) this.handleShow();
        if (!isVisible && this.props.isVisible) this.handleClose();
    }

    handleShow() {
        const {animationType, onShow, ariaHideApp, appElement} = this.props;

        if (ariaHideApp) {
            ariaHiddenInstances += 1;
            ariaAppHider.hide(appElement);
        }

        if (animationType === 'slide') {
            this.animateSlideIn(onShow);
        } else if (animationType === 'fade') {
            this.animateFadeIn(onShow);
        } else {
            onShow();
        }
    }

    handleClose() {
        const {animationType, onDismiss, ariaHideApp, appElement} = this.props;

        if (animationType === 'slide') {
            this.animateSlideOut(onDismiss);
        } else if (animationType === 'fade') {
            this.animateFadeOut(onDismiss);
        } else {
            onDismiss();
        }

        if (ariaHideApp && ariaHiddenInstances > 0) {
            ariaHiddenInstances -= 1;

            if (ariaHiddenInstances === 0) {
                ariaAppHider.show(appElement);
            }
        }
    }

    // Fade Animation Implementation
    animateFadeIn = (callback) => {
        if (this.state.animationFade) {
            this.state.animationFade.stop();
        }

        const animationFade = Animated.timing(this.state.opacityFade, {
            toValue: 1,
            duration: 300,
        });

        this.setState(
            {
                animationFade,
            },
            () => {
                requestAnimationFrame(() => {
                    this.setState({styleFade: {display: 'flex'}}, () =>
                        this.state.animationFade.start(callback)
                    );
                });
            }
        );
    };

    animateFadeOut = (callback) => {
        if (this.state.animationFade) {
            this.state.animationFade.stop();
        }

        const animationFade = Animated.timing(this.state.opacityFade, {
            toValue: 0,
            duration: 300,
        });

        this.setState(
            {
                animationFade,
            },
            () => {
                requestAnimationFrame(() => {
                    this.state.animationFade.start(() => {
                        this.setState(
                            {
                                styleFade: {display: 'none'},
                            },
                            callback
                        );
                    });
                });
            }
        );
    };
    // End of Fade Animation Implementation

    // Slide Animation Implementation
    animateSlideIn = (callback) => {
        if (this.state.animationSlide) {
            this.state.animationSlide.stop();
        }

        const animationSlide = Animated.timing(this.state.slideTranslation, {
            toValue: 1,
            easing: Easing.out(Easing.poly(4)),
            duration: 300,
        });

        this.setState(
            {
                animationSlide,
            },
            () => {
                requestAnimationFrame(() => {
                    this.setState({styleFade: {display: 'flex'}}, () =>
                        this.state.animationSlide.start(callback)
                    );
                });
            }
        );
    };

    animateSlideOut = (callback) => {
        if (this.state.animationSlide) {
            this.state.animationSlide.stop();
        }

        const animationSlide = Animated.timing(this.state.slideTranslation, {
            toValue: 0,
            easing: Easing.in(Easing.poly(4)),
            duration: 300,
        });

        this.setState(
            {
                animationSlide,
            },
            () => {
                requestAnimationFrame(() => {
                    this.state.animationSlide.start(() => {
                        this.setState(
                            {
                                styleFade: {display: 'none'},
                            },
                            callback
                        );
                    });
                });
            }
        );
    };

    // End of Slide Animation Implementation

    getAnimationStyle() {
        const {isVisible, animationType} = this.props;
        const {styleFade} = this.state;

        if (animationType === 'slide') {
            return [
                {
                    transform: [
                        {
                            translateY: this.state.slideTranslation.interpolate({
                                inputRange: [0, 1],
                                outputRange: [Dimensions.get('window').height, 0],
                                extrapolate: 'clamp',
                            }),
                        },
                    ],
                },
                styleFade,
            ];
        }
        if (animationType === 'fade') {
            return [{opacity: this.state.opacityFade}, styleFade];
        }

        return [styles[isVisible ? 'visible' : 'hidden']];
    }

    render() {
        const {transparent, children, onBackdropPress, backdropColor, isVisible} = this.props;

        const transparentStyle = transparent
            ? styles.bgTransparent
            : styles.bgNotTransparent;
        const animationStyle = this.getAnimationStyle();

        return (


            <View
                //pointerEvents='none'
            >
                <ModalPortal>

                    <Animated.View
                        aria-modal="true"
                        style={[styles.baseStyle, transparentStyle, animationStyle]}
                    >
                        <TouchableHighlight
                            style={[transparent ? {} : {
                                position: 'fixed',
                                top: 0,
                                right: 0,
                                bottom: 0,
                                left: 0,
                                backgroundColor: backdropColor ? backdropColor : Colors.gray,
                                opacity: 0.8,
                                // zIndex:10000
                            }, animationStyle]}
                            onPress={onBackdropPress}
                        >
                            <View/>
                        </TouchableHighlight>
                        {children}
                        {
                            (this.props.isVisible && this.props.isVisible.length > 0) && <Toast
                                config={toastConfig}

                            />
                        }

                    </Animated.View>
                </ModalPortal>

            </View>


        );
    }
}
